export default {"src":"/_next/static/media/checkmark.f68151ef.svg","height":14,"width":18,"blurWidth":0,"blurHeight":0};